/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { DXP_DATA_ID_FORM_ERROR } from '../../Constants/DataIds';
import { ButtonList } from '../ButtonList';
import { ErrorMessage } from '../ErrorMessage';
import { FormProps, formPropsDefaults } from './Form.props';
import { FORM_LAYOUT_HORIZONTAL } from './types/FormLayout.types';
import { FORM_THEME_DARK, FORM_THEME_LITE } from './types/FormTheme.types';

/**
 * SDS Form component.
 */
export const Form = (props: FormProps): JSX.Element => {
  const { buttonKeys, buttons, buttonsPosition, children, classes, errorMessage, layout, legend, theme } = {
    ...formPropsDefaults,
    ...props,
  };

  const formClasses = clsx(`sds-form`, classes, {
    [`form--dark`]: theme === FORM_THEME_DARK,
    [`form--horizontal`]: layout === FORM_LAYOUT_HORIZONTAL,
    [`form--lite`]: theme === FORM_THEME_LITE,
  });

  return (
    <form
      className={formClasses}
      onSubmit={(event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
      }}
    >
      <fieldset className="sds-fieldset">
        <legend className="sr-only">{legend}</legend>
        {children}
      </fieldset>
      {errorMessage && (
        <div className="sds-form-error" data-id={DXP_DATA_ID_FORM_ERROR}>
          <ErrorMessage message={errorMessage} />
        </div>
      )}
      {buttons.length > 0 && (
        <div className="sds-form-footer">
          <ButtonList buttonKeys={buttonKeys} buttons={buttons} buttonsPosition={buttonsPosition} />
        </div>
      )}
    </form>
  );
};
